import { Component, EventEmitter, Input, OnInit, Output, TemplateRef, ViewChild, ElementRef } from "@angular/core";
import { DatePipe } from "@angular/common";
import { FormControl } from "@angular/forms";
import * as _ from "lodash";
import * as XLSX from 'xlsx';
import { Combo2Service, ExcelService, ReportService } from "../../../services/index";
import { SalesOrderService } from "../../../services/salesOrder.service";
import swal from "sweetalert2";


@Component({
  selector: "outstandingDatewiseReport",
  templateUrl: "./outstandingDatewiseReport.html"
})
export class outstandingDatewiseReportComponent implements OnInit {
  @Input("tabTitle") title: string;
  @Input("tabID") tabID: string;
  @Input() active = false;
  @Input() dataContext;
  @Output() tabUpdateEvent = new EventEmitter();
  @ViewChild("snoTemplate") snoTemplate: TemplateRef<any>;
  @ViewChild('table') table: ElementRef;
  @ViewChild('close') close!: ElementRef;

  finyearCtrl: FormControl = new FormControl();
  seasonCtrl: FormControl = new FormControl();
  typeCtrl: FormControl = new FormControl();
  orderCtrl: FormControl = new FormControl();
  isLoadMask: Promise<any>;

  seasonList = [];
  seasonyearList = [];
  seasonfinList = [];
  exceldata: any;
  year_id: any;
  tabcol = {};
  salesPerson = "";
  reportDate = new Date().toLocaleDateString("fr-FR");
  party: any;
  partywise: any;
  filter = {
    from1: "",
    to1: "",
    from2: "",
    to2: "",
    from3: "",
    to3: "",
    from4: "",
    to4: "",
    from5: "",
    to5: "",
    from6: "",
    to6: "",
    groupby: "outstanding",
  };
  options = { year: 'numeric', month: 'short', };
  filter1: any = {};
  coltot = 0;
  agenttotval = [];
  partytotval = [];
  inpDate: any;
  agentList: any = [];
  partyList: any = [];
  partyLength = 0;
  data: any = [];
  partyData: any = [];
  totBillAmt = 0;
  totcalc: any = [];
  finyearList: any;
  agentLen= 0;
  partyLen= 0;
  stcLen = 1;

  constructor(
    private salesPlan: SalesOrderService,
    private combo2Service: Combo2Service,
    private reportService: ReportService,
    public datePipe: DatePipe,
    private excelService: ExcelService
  ) {

  }

  ngOnInit(): void {

    this.bindValue();
  }


  // bind input date field value for dynamic column name

  bindValue() {
    if (this.filter.from2 == "" || this.filter.from2 != "") {
      let newdat = this.addChangeDate(this.filter.to1);
      this.filter.from2 = newdat;
    }
    if (this.filter.from3 == "" || this.filter.from3 != "") {
      let newdat = this.addChangeDate(this.filter.to2);
      this.filter.from3 = newdat;
    }
    if (this.filter.from4 == "" || this.filter.from4 != "") {
      let newdat = this.addChangeDate(this.filter.to3);
      this.filter.from4 = newdat;
    }
    if (this.filter.from5 == "" || this.filter.from5 != "") {
      let newdat = this.addChangeDate(this.filter.to4);
      this.filter.from5 = newdat;
    }
    if (this.filter.from6 == "" || this.filter.from6 != "") {
      let newdat = this.addChangeDate(this.filter.to5);
      this.filter.from6 = newdat;
    }

    this.filter1 = {
      from1: new Date(this.filter.from1).toLocaleDateString('en-US', this.options),
      to1: new Date(this.filter.to1).toLocaleDateString('en-US', this.options),
      from2: new Date(this.filter.from2).toLocaleDateString('en-US', this.options),
      to2: new Date(this.filter.to2).toLocaleDateString('en-US', this.options),
      from3: new Date(this.filter.from3).toLocaleDateString('en-US', this.options),
      to3: new Date(this.filter.to3).toLocaleDateString('en-US', this.options),
      from4: new Date(this.filter.from4).toLocaleDateString('en-US', this.options),
      to4: new Date(this.filter.to4).toLocaleDateString('en-US', this.options),
      from5: new Date(this.filter.from5).toLocaleDateString('en-US', this.options),
      to5: new Date(this.filter.to5).toLocaleDateString('en-US', this.options),
      from6: new Date(this.filter.from6).toLocaleDateString('en-US', this.options),
      to6: new Date(this.filter.to6).toLocaleDateString('en-US', this.options),
    }

    if (this.filter1.from1 == "Invalid Date") {
      this.filter1.from1 = "Up";
    }

  }


  // give an to_date input then next from_date input dynamically change the next date
  addChangeDate(dt: any) {
    let ts = "T00:00:00.000Z";
    let dtfomt = dt.concat("", ts);
    let date = new Date(dtfomt);
    date.setDate(date.getDate() + 1);
    let rets = date.toLocaleDateString("fr-FR");
    let newdat = rets.split("/").reverse().join("-");
    return newdat;
  }

  //clear function for clear the all input fields in the modal window
  clear() {
    this.filter.from1 = "";
    this.filter.from2 = "";
    this.filter.from3 = "";
    this.filter.from4 = "";
    this.filter.from5 = "";
    this.filter.from6 = "";
    this.filter.to1 = "";
    this.filter.to2 = "";
    this.filter.to3 = "";
    this.filter.to4 = "";
    this.filter.to5 = "";
    this.filter.to6 = "";
  }


  // Get agentwise List 
  loadOutstandingList() {
    this.stcLen = 1;
    let that = this;
    if (this.agentLen > 0) {
      let a = this.agentList.length;
      this.agentList.splice(0, a);
      this.agenttotval.splice(0, this.agenttotval.length);
    }
    let params = {
      filter: JSON.stringify(this.filter),
    };
    if (this.filter.to1 != "" && this.filter.to2 != "" && this.filter.to3 != "" && this.filter.to4 != "" && this.filter.to5 != "" && this.filter.to6 != "") {
      this.close.nativeElement.click();
      that.reportService.getoutstandingDatewiseReport(params).then(function (res: any) {
        that.data = res;
        that.data = Object.values(that.data);
        let a = _.flattenDeep(that.data);
        that.agentList = _.groupBy(a, 'agent_name');
        that.agentList = Object.values(that.agentList);
        that.common(that.agentList);
      });
    } else {
      swal("ERROR", "Please Enter the all Date fields", "error");
      return;
    }
  }


  // common function is used for compare the dates and we shold 0 which date period is empty  
  common(arr) {

    if (this.filter.from1 == '' || this.filter.from1 == 'Up') {
      this.filter.from1 = "2010-01-01";
    }

    this.inpDate = [
      { from: this.filter.from1, to: this.filter.to1 },
      { from: this.filter.from2, to: this.filter.to2 },
      { from: this.filter.from3, to: this.filter.to3 },
      { from: this.filter.from4, to: this.filter.to4 },
      { from: this.filter.from5, to: this.filter.to5 },
      { from: this.filter.from6, to: this.filter.to6 },
    ];

    this.inpDate.forEach(ele => {

      let a = 0;

      arr.forEach(el => {

        a = el.findIndex(x => x.dfrom === ele.from);

        if (a == -1) {

          if (!el[0].party_name) {

            el.push(
              {
                agent_name: el[0].agent_name,
                agent_id: el[0].agent_id,
                team: el[0].team,
                dfrom: ele.from,
                dto: ele.to,
                pend_amount: 0,
              })
          } else {
            el.push(
              {
                party_id: el[0].party_id,
                party_name: el[0].party_name,
                dcdt: el[0].dcdt,
                dfrom: ele.from,
                dto: ele.to,
                pend_amount: 0,
                agent_id: el[0].agent_id,
                agent_name: el[0].agent_name,
              })
          }

        }
      });

    });
    for (let i = 0; i < arr.length; i++) {
      arr[i] = _.sortBy(arr[i], ['dfrom']);
    }

    if (!arr[0].party_name) {
      this.agentList = arr;
      this.agentLen = this.agentList.length;
      this.calc(this.agentList);
    } else {
      this.partyList = arr;
      this.partyLen = this.partyList.length;
      this.calc(this.partyList);
    }
  }


  // calculation for total pending amount
  calc(list: any) {
    for (let i = 0; i <= 5; i++) {
      this.coltot = 0;
      list.forEach((el, index) => {
        index = i;
        this.coltot += el[index].pend_amount;
      });
      if (!list[0][0].party_name) {
        this.agenttotval.push(this.coltot);
      } else {
        this.partytotval.push(this.coltot);
      }
    }

    let tot = 0;

    if (!list[0][0].party_name) {
      for (let i = 0; i < this.agenttotval.length; i++) {
        tot += this.agenttotval[i];
      }
      this.agenttotval.push(tot);
    } else {
      for (let i = 0; i < this.partytotval.length; i++) {
        tot += this.partytotval[i];
      }
      this.partytotval.push(tot);
    }
    
  }


  // Get partywise List (2nd level)
  
  loadpartywise(partywise: any) {

    this.stcLen = 0;
    this.partytotval.splice(0, this.partytotval.length);

    let that = this;
    
    this.salesPerson = partywise[0].agent_name;
    let params = {
      filter: JSON.stringify(partywise),
    };
    that.reportService.getoutstandingPartyDatewiseReport(params).then(function (res: any) {
      that.partyData = res;
      that.partyData = Object.values(that.partyData);
      let a = _.flattenDeep(that.partyData);
      that.partyList = _.groupBy(a, 'party_name');
      that.partyList = Object.values(that.partyList);
      that.common(that.partyList);
      that.partyLen = that.partyList.length;
    });
    
  }

  // show and hidden the table 1 and table 2
  onbackbutton() {
    this.partyLen = 0;
    this.loadOutstandingList();
  }

  // export the html elements into excel sheet
  exportToExcel() {
    const ws: XLSX.WorkSheet = XLSX.utils.table_to_sheet(
      this.table.nativeElement
    );
    const wb: XLSX.WorkBook = XLSX.utils.book_new();
    XLSX.utils.book_append_sheet(wb, ws, 'Sheet1');

    /* save to file */
    XLSX.writeFile(wb, 'CodSheet.xlsx');
  }
}




// WEBPACK FOOTER //
// /Users/afsarahamed/Documents/symatis/projects/hyatt-angularweb/src/app/components/report/OutstandingReport/outstandingDatewiseReport.ts